import { render, staticRenderFns } from "./transactionDialog.vue?vue&type=template&id=680454a4&scoped=true&"
import script from "./transactionDialog.vue?vue&type=script&lang=js&"
export * from "./transactionDialog.vue?vue&type=script&lang=js&"
import style0 from "./transactionDialog.vue?vue&type=style&index=0&id=680454a4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680454a4",
  null
  
)

export default component.exports